/**
 * NotificationBell — sininho para o admin.
 * Mostra contadores agregados: solicitações de abatimento, comprovantes pendentes, romaneios pendentes, chat unread.
 * Polling a cada 15s.
 */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Bell, FileText, Receipt, ArrowLeftRight, MessageCircle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NotificationBell() {
  const navigate = useNavigate();
  const [counts, setCounts] = useState({ total: 0, pendentes_abatimento: 0, comprovantes_pendentes: 0, romaneios_pendentes: 0, chat_unread: 0 });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const refresh = () => {
      axios.get(`${API}/admin/notifications/center`)
        .then(r => setCounts(r.data))
        .catch(() => {});
    };
    refresh();
    const t = setInterval(refresh, 15000);
    return () => clearInterval(t);
  }, []);

  const Item = ({ icon: Icon, label, count, color, onClick, testid }) => (
    <button onClick={onClick} disabled={count === 0}
      className="w-full flex items-center justify-between gap-3 px-3 py-2 hover:bg-gray-50 dark:hover:bg-gray-700/40 disabled:opacity-50 disabled:cursor-not-allowed rounded-lg text-left transition-colors"
      data-testid={testid}>
      <div className="flex items-center gap-2.5">
        <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${color}`}>
          <Icon className="w-4 h-4" />
        </div>
        <span className="text-sm font-medium">{label}</span>
      </div>
      <span className={`text-sm font-bold ${count > 0 ? 'text-red-600' : 'text-gray-400'}`}>{count}</span>
    </button>
  );

  return (
    <div className="relative">
      <button onClick={() => setOpen(!open)}
        className="relative p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-gray-700 dark:text-gray-300"
        data-testid="notif-bell-btn">
        <Bell className="w-5 h-5" />
        {counts.total > 0 && (
          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] font-bold rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1" data-testid="notif-bell-badge">
            {counts.total > 99 ? '99+' : counts.total}
          </span>
        )}
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-30" onClick={() => setOpen(false)} />
          <div className="absolute right-0 mt-2 w-72 bg-white dark:bg-gray-800 rounded-xl shadow-2xl border border-gray-200 dark:border-gray-700 z-40 p-2" data-testid="notif-bell-dropdown">
            <div className="px-2 py-1.5 border-b border-gray-200 dark:border-gray-700 mb-1">
              <p className="font-bold text-sm">Notificações</p>
              <p className="text-[10px] text-gray-500">{counts.total > 0 ? `${counts.total} item(ns) precisando de atenção` : 'Tudo em dia ✓'}</p>
            </div>
            <Item icon={ArrowLeftRight} label="Solicitações de abatimento" count={counts.pendentes_abatimento}
              color="bg-amber-100 text-amber-700"
              onClick={() => { setOpen(false); navigate('/dashboardadminromaneio/abatimento-requests'); }}
              testid="notif-abatimentos" />
            <Item icon={Receipt} label="Comprovantes pendentes" count={counts.comprovantes_pendentes}
              color="bg-purple-100 text-purple-700"
              onClick={() => { setOpen(false); navigate('/dashboardadminromaneio/comprovantes-cliente'); }}
              testid="notif-comprovantes" />
            <Item icon={FileText} label="Romaneios pendentes" count={counts.romaneios_pendentes}
              color="bg-blue-100 text-blue-700"
              onClick={() => { setOpen(false); navigate('/dashboardadminromaneio/romaneios'); }}
              testid="notif-romaneios" />
            <Item icon={MessageCircle} label="Mensagens não lidas" count={counts.chat_unread}
              color="bg-green-100 text-green-700"
              onClick={() => setOpen(false)}
              testid="notif-chat" />
          </div>
        </>
      )}
    </div>
  );
}
